<section class="content-section">
  <mat-tab-group class="dataset-tab-group">
    <mat-tab *ngFor="let state of states" [label]="state.config.tabLabelKey | transloco">
      <div class="tab-content-wrapper">
        <div class="section-header">
          <div>
            <h2>{{ 'ppwr.tdProfiles.title' | transloco }}</h2>
           <p>{{ ('ppwr.tdProfiles.descriptions.' + state.config.key) | transloco }}</p>
          </div>
          <button mat-stroked-button color="primary" type="button" (click)="addProfile(state)">
            <mat-icon>add</mat-icon>{{ 'common.buttons.add' | transloco }}
          </button>
        </div>

        <div class="role-list">
          <div class="empty-state" *ngIf="state.profiles.length === 0">
            <mat-icon class="empty-state-icon">description</mat-icon>
            <div class="empty-state-title">{{ 'ppwr.tdProfiles.emptyState.title' | transloco }}</div>
            <div class="empty-state-text">{{ 'ppwr.tdProfiles.emptyState.text' | transloco }}</div>
          </div>
          <div class="role-item" *ngFor="let profile of state.profiles">
            <strong>{{ profile.profileName }}</strong>
            <div class="item-actions">
              <button mat-icon-button color="primary" type="button" [attr.aria-label]="'common.buttons.edit' | transloco" (click)="editProfile(state, profile)">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                mat-icon-button
                color="warn"
                type="button"
                [attr.aria-label]="'ppwr.tdProfiles.deleteAria' | transloco"
                (click)="confirmDeleteProfile(state, profile)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</section>
